var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isTasksDashboard)?_c('tasks-dashboard'):(_vm.isAccidentManagement)?_c('accident-management-dashboard'):(_vm.isInsurance)?_c('default-dashboard'):(_vm.isAssessments)?_c('assessments-dashboard'):_c('default-dashboard')}
var staticRenderFns = []

export { render, staticRenderFns }